export default __webpack_public_path__ + "static/beige-nr-black-cork-ea59950557494a92cd9ca9449b181b7e.png";